import React from 'react';
import { motion } from 'framer-motion';
import { MailIcon, HeartHandshakeIcon } from 'lucide-react';
export function Support() {
  return <section className="py-16 px-4 bg-[#8BA888]/10" data-id="element-45">
      <motion.div initial={{
      y: 20,
      opacity: 0
    }} whileInView={{
      y: 0,
      opacity: 1
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.5
    }} className="max-w-2xl mx-auto text-center" data-id="element-46">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-white shadow-md mb-6" data-id="element-47">
          <HeartHandshakeIcon className="w-8 h-8 text-[#8BA888]" aria-hidden="true" data-id="element-48" />
        </div>

        <h2 className="text-2xl md:text-3xl font-bold text-[#3D2C2C] mb-4 font-heading" data-id="element-49">
          ¿Necesitas ayuda?
        </h2>

        <p className="text-[#5A4A4A] text-lg mb-6 leading-relaxed" data-id="element-50">
          Si tienes algún problema con la descarga, escríbenos y te ayudaremos.
        </p>

        <motion.a href="mailto:digitalkreana@gmail.com" whileHover={{
        scale: 1.02
      }} whileTap={{
        scale: 0.98
      }} className="inline-flex items-center gap-3 bg-white hover:bg-[#FDF8F3] text-[#3D2C2C] px-6 py-3 rounded-xl font-semibold transition-colors duration-200 shadow-[0_4px_15px_rgba(61,44,44,0.08)] hover:shadow-[0_6px_20px_rgba(61,44,44,0.12)] focus:outline-none focus:ring-2 focus:ring-[#8BA888] focus:ring-offset-2" aria-label="Enviar correo a digitalkreana@gmail.com" data-id="element-51">
          <MailIcon className="w-5 h-5 text-[#C96B4F]" aria-hidden="true" data-id="element-52" />
          digitalkreana@gmail.com
        </motion.a>

        <p className="mt-8 text-sm text-[#5A4A4A]/70" data-id="element-53">
          Respondemos en menos de 24 horas 💕
        </p>
      </motion.div>
    </section>;
}